














































import Vue from 'vue';
import { firebase } from 'mostra';

const adminMenuData = [
  {
    title: '展示会',
    data: [
      { to: '/', text: 'LP' },
      { to: '/ssr/', text: '展示会' },
    ],
  },
  {
    title: 'Admin',
    data: [
      { to: { name: 'admin-admin-setting' }, text: '設定' },
      { to: { name: 'admin-admin-buyer-index' }, text: 'バイヤー' },
      { to: { name: 'admin-admin-exhibitor-index' }, text: '出展者' },
      { to: { name: 'admin-admin-exhibition-index' }, text: '展示会' },
      { to: { name: 'admin-admin-brand-index' }, text: 'ブランド' },
      { to: { name: 'admin-admin-booth-index' }, text: 'ブース' },
      { to: { name: 'admin-admin-item-index' }, text: '商品' },
    ],
  },
  {
    title: 'Analysis',
    data: [
      { to: { name: 'admin-admin-analysis-favorite-index' }, text: 'チェック' },
      { to: { name: 'admin-admin-analysis-uu-index' }, text: 'ユニークユーザー数' },
      { to: { name: 'admin-admin-analysis-contact-index' }, text: 'コンタクト' },
      { to: { name: 'admin-admin-analysis-vis-index' }, text: '来場者' },
    ],
  },
  {
    title: '共通',
    data: [
      { to: { name: 'auth-signin' }, text: 'サインイン' },
      { to: { name: 'auth-signup' }, text: 'サインアップ' },
      { to: { name: 'auth-reset' }, text: 'パスワードリセット' },
    ],
  },
  {
    title: 'Account',
    data: [
      { to: { name: 'admin-admin-account-setting' }, text: '設定' },
    ],
  },
  {
    title: 'バイヤー',
    data: [
      { to: { name: 'admin-admin-buyer-modify', params: { id: 'new' } }, text: '新規登録' },
      { to: { name: 'buyer-settings-userinfo' }, text: 'ユーザ画面' },
    ],
  },
  {
    title: '出展者',
    data: [
      { to: { name: 'admin-admin-exhibitor-modify' }, text: '新規登録' },
      { to: { name: 'exhibitor-brand-top' }, text: 'ユーザ画面' },
    ],
  },
  {
    title: 'Storybook',
    data: [
      { to: '/storybook-static-web/', text: 'WEB' },
    ],
  },
  {
    title: 'Test',
    data: [
      { to: { name: 'admin-admin-cleasing' }, text: 'クレンジング' },
      // { to: { name: 'admin-test-rule' }, text: 'test-rule', },
    ],
  },
];

export default Vue.extend({
  name: 'admin-index',
  data() {
    return {
      adminMenuData: adminMenuData,
    };
  },
  // beforeRouteUpdate(to, from, next) {
  //   next();
  //   this.scrollTop();
  // },
  methods: {
    onClickChangePage(to: string | object) {
      if (typeof to === 'string') {
        window.open(to, '_blank');
      } else {
        this.$router.push(to);
      }
    },
    async onClick() {
      try {
        await firebase.auth().signOut();
      } catch (error: any) {
        this.$fatal(error);
      }
    },
    // scrollTop() {
    //   window.scrollTo({
    //     top: 0,
    //   });
    // },
  },
});

